
import io from 'socket.io-client'

const SocketIo = {}
SocketIo.install = (Vue, options) => {
  let address = 'https://api.thevortex.io'
  if (process.env.NODE_ENV === 'development') {
    address = 'http://localhost:3388'
  }

  const socket = io(address)

  socket.on('welcome', (data) => {
    console.log('welcome!!')
  })

  Vue.prototype.$socket = socket

  if (typeof window !== 'undefined') {
    window.$socket = socket
  }
}

export default SocketIo



// WEBPACK FOOTER //
// ./src/plugins/SocketIo.js